module.exports = __webpack_public_path__ + "static/img/CY.d4dda851.png";